module.exports = __webpack_public_path__ + "static/media/5DPO5.3deee158.jpg";